module.exports = __webpack_public_path__ + "static/img/5.b52cbfb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/zh/5.png
// module id = tKbj
// module chunks = 0